import { render, staticRenderFns } from "./JobList.vue?vue&type=template&id=e2d7e796&scoped=true&"
import script from "./JobList.vue?vue&type=script&lang=js&"
export * from "./JobList.vue?vue&type=script&lang=js&"
import style0 from "./JobList.vue?vue&type=style&index=0&id=e2d7e796&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2d7e796",
  null
  
)

export default component.exports